
import React from 'react'


const CallRequest = () => {
  return (
    <section className='hero'>
        <section className='bg-[#1E00FD33] w-full h-full '>
<div className='flex md:flex-col w-[70%] md:w-full mx-auto justify-between py-24'>
<div className='my-auto'>

<h2 className='text-5xl text-white font-semibold md:text-[32px] md:text-center '>Request a Call back?</h2>
<p className='text-white mt-4 text-center md:mb-14'>Want to ask any question about out services?</p>
</div>
<div className='w-[45%] md:w-[90%] md:mx-auto'>
<form className='flex flex-col request-callback rounded-2xl w-full h-full'>
    <input type="text" placeholder='Name' className='rounded-xl mb-3 focus:outline-none border-top-input pl-3 py-[15px]' />
    <input type="number" placeholder='Mobile Number' className='border-top-input mb-3 rounded-xl  focus:outline-none pl-3 py-[15px]' />
    <input type="email" placeholder="Email" className='border-top-input mb-3 rounded-xl focus:outline-none pl-3 py-[15px]' />
    <input type="text" placeholder='Country' className='border-top-input mb-3 rounded-xl focus:outline-none pl-3 py-[15px]' />
    <textarea placeholder='Message' cols="30" rows="5" className='border-top-input mb-3 pl-3 rounded-xl focus:outline-none py-[10px]'></textarea>
    <button className='bg-[#5146AE] text-white font-medium text-base py-5 rounded-xl'>Request Callback</button>

</form>
</div>
</div>
        </section>
    </section>
  )
}

export default CallRequest